/* eslint-disable no-loss-of-precision */
import Round1 from '../Eyes/Round1'
import Round2 from '../Eyes/Round2'
import Round3 from '../Eyes/Round3'
import Oval1 from '../Eyes/Oval1'
import Oval2 from '../Eyes/Oval2'
import Oval3 from '../Eyes/Oval3'
import Oval4 from '../Eyes/Oval4'
import Point1 from '../Eyes/Point1'
import Point2 from '../Eyes/Point2'
import Point3 from '../Eyes/Point3'

const data = [
  {
    id: 'Round2',
    svg: Round2,
    positioning: {
      pointNarrow: {
        y: 93.30712890625,
        scaleX: 1,
        scale: 0.9,
        spacingOffset: -2,
      },
      pointMedium: {
        y: 93.32487487792969,
        scaleX: 1,
        scale: 0.9,
        spacingOffset: -2,
      },
      pointWide: {
        y: 93.34635925292969,
        scaleX: 1.15,
        scale: 0.9,
        spacingOffset: -2,
      },
      roundNarrow: {
        y: 95.3892822265625,
        scaleX: 0.9,
        scale: 0.9,
        spacingOffset: -2,
      },
      roundMedium: {
        y: 95.74919128417969,
        scaleX: 1.05,
        scale: 0.9,
        spacingOffset: -2,
      },
      roundWide: {
        y: 95.15873718261719,
        scaleX: 1.15,
        scale: 0.9,
        spacingOffset: -2,
      },
      squareNarrow: {
        y: 93.96662902832031,
        scaleX: 1,
        scale: 0.9,
        spacingOffset: -2,
      },
      squareMedium: {
        y: 93.02166748046875,
        scaleX: 1,
        scale: 0.9,
        spacingOffset: -2,
      },
      squareWide: {
        y: 93.42739868164062,
        scaleX: 1.15,
        scale: 0.9,
        spacingOffset: -2,
      },
    },
  },
  {
    id: 'Round3',
    svg: Round3,
    positioning: {
      pointNarrow: {
        y: 93.95903015136719,
        scaleX: 0.95,
        scale: 0.9,
        spacingOffset: -2,
      },
      pointMedium: {
        y: 93.32258605957031,
        scaleX: 1,
        scale: 0.9,
        spacingOffset: -2,
      },
      pointWide: {
        y: 93.15147399902344,
      },
      roundNarrow: {
        y: 95.2071533203125,
        scaleX: 0.9,
        scale: 0.9,
        spacingOffset: -2,
      },
      roundMedium: {
        y: 95.93214416503906,
        scaleX: 1,
        scale: 0.9,
        spacingOffset: -2,
      },
      roundWide: {
        y: 95.44126892089844,
        scaleX: 1.15,
        scale: 0.9,
        spacingOffset: -2,
      },
      squareNarrow: {
        y: 93.120849609375,
        scaleX: 1,
        scale: 0.9,
        spacingOffset: -2,
      },
      squareMedium: {
        y: 93.839599609375,
        scaleX: 1,
        scale: 0.9,
        spacingOffset: -2,
      },
      squareWide: {
        y: 93.25088500976562,
        scaleX: 1.1,
        scale: 0.9,
        spacingOffset: -2,
      },
    },
  },
  {
    id: 'Oval1',
    svg: Oval1,
    positioning: {
      pointNarrow: {
        y: 93.07630920410156,
        scaleX: 0.95,
        scale: 0.9,
        spacingOffset: -2,
      },
      pointMedium: {
        y: 93.68414306640625,
        scaleX: 1,
        scale: 0.9,
        spacingOffset: -2,
      },
      pointWide: {
        y: 93.00019836425781,
      },
      roundNarrow: {
        y: 95.96878051757812,
        scaleX: 0.95,
        scale: 0.9,
        spacingOffset: -2,
      },
      roundMedium: {
        y: 95.05326843261719,
        scaleX: 1,
        scale: 0.9,
        spacingOffset: -2,
      },
      roundWide: {
        y: 95.93629455566406,
        scaleX: 1.15,
        scale: 0.9,
        spacingOffset: -2,
      },
      squareNarrow: {
        y: 93.04240417480469,
        scaleX: 0.95,
        scale: 0.9,
        spacingOffset: -2,
      },
      squareMedium: {
        y: 93.9722900390625,
        scaleX: 1,
        scale: 0.9,
        spacingOffset: -2,
      },
      squareWide: {
        y: 93.73801803588867,
        scaleX: 1.1,
        scale: 0.9,
        spacingOffset: -2,
      },
    },
  },
  {
    id: 'Oval2',
    svg: Oval2,
    positioning: {
      pointNarrow: {
        y: 93.28604125976562,
        scaleX: 0.95,
        scale: 0.9,
        spacingOffset: -2,
      },
      pointMedium: {
        y: 93.33833312988281,
        scaleX: 1,
        scale: 0.9,
        spacingOffset: -2,
      },
      pointWide: {
        y: 93.15689086914062,
      },
      roundNarrow: {
        y: 95.08995056152344,
        scaleX: 0.9,
        scale: 0.9,
        spacingOffset: -2,
      },
      roundMedium: {
        y: 95.29824829101562,
        scaleX: 1,
        scale: 0.9,
        spacingOffset: -2,
      },
      roundWide: {
        y: 95.45654296875,
        scaleX: 1.1,
        scale: 0.9,
        spacingOffset: -2,
      },
      squareNarrow: {
        y: 93.19206237792969,
        scaleX: 0.95,
        scale: 0.9,
        spacingOffset: -2,
      },
      squareMedium: {
        y: 93.52938842773438,
        scaleX: 1,
        scale: 0.9,
        spacingOffset: -2,
      },
      squareWide: {
        y: 93.45450592041016,
        scaleX: 1.1,
        scale: 0.9,
        spacingOffset: -2,
      },
    },
  },
  {
    id: 'Oval3',
    svg: Oval3,
    positioning: {
      pointNarrow: {
        y: 93.71565246582031,
        scaleX: 0.95,
        scale: 0.9,
        spacingOffset: -2,
      },
      pointMedium: {
        y: 93.77110290527344,
        scaleX: 1,
        scale: 0.9,
        spacingOffset: -2,
      },
      pointWide: {
        y: 93.28594970703125,
      },
      roundNarrow: {
        y: 95.3001708984375,
        scaleX: 0.9,
        scale: 0.9,
        spacingOffset: -2,
      },
      roundMedium: {
        y: 95.24746704101562,
        scaleX: 1,
        scale: 0.9,
        spacingOffset: -2,
      },
      roundWide: {
        y: 95.00927734375,
        scaleX: 1.1,
        scale: 0.9,
        spacingOffset: -2,
      },
      squareNarrow: {
        y: 93.85433959960938,
        scaleX: 0.95,
        scale: 0.9,
        spacingOffset: -2,
      },
      squareMedium: {
        y: 93.47291564941406,
        scaleX: 1,
        scale: 0.9,
        spacingOffset: -2,
      },
      squareWide: {
        y: 93.59615325927734,
        scaleX: 1.1,
        scale: 0.9,
        spacingOffset: -2,
      },
    },
  },
  {
    id: 'Oval4',
    svg: Oval4,
    positioning: {
      pointNarrow: {
        y: 93.10989379882812,
        scaleX: 0.95,
        scale: 0.9,
        spacingOffset: -2,
      },
      pointMedium: {
        y: 93.77169799804688,
        scaleX: 0.95,
        scale: 0.9,
        spacingOffset: -2,
      },
      pointWide: {
        y: 93.14305114746094,
      },
      roundNarrow: {
        y: 95.73538208007812,
        scaleX: 0.9,
        scale: 0.9,
        spacingOffset: -2,
      },
      roundMedium: {
        y: 95.26643371582031,
        scaleX: 1,
        scale: 0.9,
        spacingOffset: -2,
      },
      roundWide: {
        y: 95.41133117675781,
        scaleX: 1.1,
        scale: 0.9,
        spacingOffset: -2,
      },
      squareNarrow: {
        y: 93.21641540527344,
        scaleX: 0.95,
        scale: 0.9,
        spacingOffset: -2,
      },
      squareMedium: {
        y: 93.84042358398438,
        scaleX: 1,
        scale: 0.9,
        spacingOffset: -2,
      },
      squareWide: {
        y: 93.946533203125,
        scaleX: 1.1,
        scale: 0.9,
        spacingOffset: -2,
      },
    },
  },
  {
    id: 'Point1',
    svg: Point1,
    positioning: {
      pointNarrow: {
        y: 93.44035339355469,
        scaleX: 0.95,
        scale: 0.9,
        spacingOffset: -2,
      },
      pointMedium: {
        y: 93.63870239257812,
        scaleX: 1,
        scale: 0.9,
        spacingOffset: -2,
      },
      pointWide: {
        y: 93.37164306640625,
      },
      roundNarrow: {
        y: 95.79067993164062,
        scaleX: 0.9,
        scale: 0.9,
        spacingOffset: -2,
      },
      roundMedium: {
        y: 95.89167785644531,
        scaleX: 1,
        scale: 0.9,
        spacingOffset: -2,
      },
      roundWide: {
        y: 95.08529663085938,
        scaleX: 1.1,
        scale: 0.9,
        spacingOffset: -2,
      },
      squareNarrow: {
        y: 93.0565185546875,
        scaleX: 0.95,
        scale: 0.9,
        spacingOffset: -2,
      },
      squareMedium: {
        y: 93.21092224121094,
        scaleX: 1,
        scale: 0.9,
        spacingOffset: -2,
      },
      squareWide: {
        y: 93.2054443359375,
        scaleX: 1.1,
        scale: 0.9,
        spacingOffset: -2,
      },
    },
  },
  {
    id: 'Point2',
    svg: Point2,
    positioning: {
      pointNarrow: {
        y: 93.64619445800781,
        scaleX: 0.95,
        scale: 0.9,
        spacingOffset: -2,
      },
      pointMedium: {
        y: 93.86540222167969,
        scaleX: 1,
        scale: 0.9,
        spacingOffset: -2,
      },
      pointWide: {
        y: 93.34715270996094,
        scaleX: 1.1,
        scale: 0.9,
        spacingOffset: -2,
      },
      roundNarrow: {
        y: 95.77444458007812,
        scaleX: 0.9,
        scale: 0.9,
        spacingOffset: -2,
      },
      roundMedium: {
        y: 95.15621948242188,
        scaleX: 1,
        scale: 0.9,
        spacingOffset: -2,
      },
      roundWide: {
        y: 95.91471862792969,
        scaleX: 1.1,
        scale: 0.9,
        spacingOffset: -2,
      },
      squareNarrow: {
        y: 93.65916442871094,
        scaleX: 0.95,
        scale: 0.9,
        spacingOffset: -2,
      },
      squareMedium: {
        y: 93.15829467773438,
        scaleX: 1,
        scale: 0.9,
        spacingOffset: -2,
      },
      squareWide: {
        y: 93.46540832519531,
        scaleX: 1.1,
        scale: 0.9,
        spacingOffset: -2,
      },
    },
  },
  {
    id: 'Point3',
    svg: Point3,
    positioning: {
      pointNarrow: {
        y: 93.73884582519531,
        scaleX: 0.95,
        scale: 0.9,
        spacingOffset: -2,
      },
      pointMedium: {
        y: 93.14222717285156,
        scaleX: 1,
        scale: 0.9,
        spacingOffset: -2,
      },
      pointWide: {
        y: 93.12467956542969,
      },
      roundNarrow: {
        y: 95.02168273925781,
        scaleX: 0.9,
        scale: 0.9,
        spacingOffset: -2,
      },
      roundMedium: {
        y: 95.93836975097656,
        scaleX: 1,
        scale: 0.9,
        spacingOffset: -2,
      },
      roundWide: {
        y: 95.11984252929688,
        scaleX: 1.1,
        scale: 0.9,
        spacingOffset: -2,
      },
      squareNarrow: {
        y: 93.25044250488281,
        scaleX: 0.95,
        scale: 0.9,
        spacingOffset: -2,
      },
      squareMedium: {
        y: 93.35743713378906,
        scaleX: 1,
        scale: 0.9,
        spacingOffset: -2,
      },
      squareWide: {
        y: 93.72244262695312,
        scaleX: 1.1,
        scale: 0.9,
        spacingOffset: -2,
      },
    },
  },
  {
    id: 'Round1',
    svg: Round1,
    positioning: {
      pointNarrow: {
        y: 93.63673400878906,
        scaleX: 0.95,
        scale: 0.9,
        spacingOffset: -2,
      },
      pointMedium: {
        y: 93.94682312011719,
        scaleX: 0.9,
        scale: 0.9,
        spacingOffset: -2,
      },
      pointWide: {
        y: 93.7716064453125,
      },
      roundNarrow: {
        y: 95.07666015625,
        scaleX: 0.9,
        scale: 0.9,
        spacingOffset: -2,
      },
      roundMedium: {
        y: 95.35345458984375,
        scaleX: 1,
        scale: 0.9,
        spacingOffset: -2,
      },
      roundWide: {
        y: 95.31605529785156,
        scaleX: 1.1,
        scale: 0.9,
        spacingOffset: -2,
      },
      squareNarrow: {
        y: 93.26057434082031,
        scaleX: 0.95,
        scale: 0.9,
        spacingOffset: -2,
      },
      squareMedium: {
        y: 93.89822387695312,
        scaleX: 1,
        scale: 0.9,
        spacingOffset: -2,
      },
      squareWide: {
        y: 93.48231506347656,
        scaleX: 1.1,
        scale: 0.9,
        spacingOffset: -2,
      },
    },
  },
]

export default data
